// DatePickerComponent.jsx
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import './RFH.scss';

const RFHdatePicker = ({ name }) => {
    const { control} = useFormContext();
  
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            className='date-picker'
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                error: !!error,
                helperText: error?.message,
                style: { height: '40px !important',
                 }, // Adjust the height here
              },
            }}
            {...field}
          />
        )}
      />
    );
  };
  

export default React.memo(RFHdatePicker);
